export enum EData {
  LOGIN = "login",
  ITEMS = "items",
  ACCOUNTS = "accounts",
  NAVBAR = "navbar",
  SEARCH_BAR = "searchbar",
  TRENDING_ROW = "trendingRow",
}

export enum EInputType {
  TEXT = "text",
  PASSWORD = "password",
  RETYPE_PW = "retypePassword",
}

export enum EAssetName {
  LOGO = "logo",
  AVATAR = "avatar",
  LENS = "lens",
  BOOKMARK_EMPTY = "iconBookmarkEmpty",
  BOOKMARK_FULL = "iconBookmarkFull",
}

export enum ECategory {
  MOVIE = "Movie",
  TV_SERIES = "TV Series",
}

export enum ERating {
  LOW = "E",
  MEDIUM = "PG",
  HIGH = "18+",
}

export enum EFormId {
  PASSWORD = "passwordField",
  USERNAME = "usernameField",
  RETYPE = "retypeField",
}

export enum EItemActionType {
  TRENDING_ITEMS = "trending-items",
  RECOMMENDED_ITEMS = "recommended_items",
  MOVIES = "movies",
  SERIES = "series",
  LOADING = "loading",
  BOOKMARKED = "bookmarked",
  REMOVE_BOOKMARK = "remove_bookmark",
  CALLED_SAVED = "called_saved",
}

export enum EParams {
  QUERY = "q",
}
